import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { toast } from "react-toastify";
import CounsellingSessionsAddPopup from "./CounsellingSessionsAddPopup";
import {
  deleteCounselling,
  fetchCounselling,
  resetState,
} from "../../store/ProgramCounselling";
import moment from "moment";
import DeleteConfirmation from "../ConfirmBox";
import { useTranslation } from "react-i18next";

interface ICounsellingSessionsTab {
  programId?: string;
}

const CounsellingSessions: React.FC<ICounsellingSessionsTab> = ({
  programId,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();
  const [open, setOpen] = useState<number>(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);
  const storedData = localStorage.getItem("loginData");
  const {
    programCounselling: counsellingSessions,
    loading,
    error,
  } = useSelector((state: RootState) => state.programCounselling);
  const [deleteItemId, setDeleteItemId] = useState<string | null>(null);

  let accessToken = ""; // Add logic to set accessToken

  useEffect(() => {
    if (accessToken && !isLoggedIn) {
      // navigate('/');
    }
  }, [accessToken, isLoggedIn]);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleDelete = (counsellingId: string) => {
    // Dispatch the delete action
    dispatch(deleteCounselling({ counsellingID: counsellingId })).then(() => {
      dispatch(fetchCounselling({ programId: programId ?? "" })).then(() => {
        toast.success(t("adminPrograms.counsellingForm.deletedSuccess", "Successfully Deleted"));
        setDeleteItemId(null);
      });
    });
  };
  const handleCancel = () => {
    setDeleteItemId(null);
  };

  useEffect(() => {
    dispatch(resetState());
    if (programId) {
      dispatch(fetchCounselling({ programId }));
    }
  }, [dispatch, programId]);

  useEffect(() => {    
  }, [counsellingSessions]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        {loading && (
          <div
            className="border-t-4 border-solid h-16 w-16 border-b-4 border-r-4 border-l-4 rounded-full animate-spin"
            style={{ borderColor: "#B4804A" }}
          />
        )}
      </div>
    );
  }

  
  return (
    <div className="px-8 pb-2 max-h-[calc(100vh-280px)] overflow-y-auto mt-2">
      <div className="flex flex-wrap overflow-y-scroll max-h-full scrollbar-hide">
        {counsellingSessions.map((session) => (
          <>
            <div className="md:basis-1/2">
              <h4 className="border-b-2 w-fit mb-3 mt-4 border-[#ADB2B5]">
                {moment.utc(session.date).format("dddd, MMMM D")}
              </h4>
              <div className="flex flex-wrap">
                {session.slots.map((slot) => (
                  <div>
                  <button
                    className={` md:basis-1/5 border h-12 min-w-32 px-6 justify-center py-3 text-[#041B44] relative rounded-lg m-2 border-[#041B44] hover:bg-[#041B44] hover:text-white ${
                      slot.isBooked === true
                        ? "bg-[#C7C7C7] text-white border-[#C7C7C7]"
                        : ""
                    }`}
                  >
                    <span>
                      {typeof slot.time === "string" && /^\d{1,2}:\d{2}/.test(slot.time)
                        ? moment(slot.time, ["HH:mm", "HH:mm:ss", "hh:mm A"]).format("HH:mm")
                        : moment.utc(slot.time).isValid()
                        ? moment.utc(slot.time).format("HH:mm")
                        : String(slot.time)}
                    </span>
                    <span
                      className="absolute cursor-pointer inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-[#83969F]  -top-2 -end-2 "
                      onClick={() => setDeleteItemId(slot.id ?? null)}
                    >
                      <img
                        src={`${
                          slot.isBooked === true
                            ? ""
                            : "./images/blue-close.png"
                        } `}
                        alt="close"
                      />
                    </span>
                    
                  </button>
                  {deleteItemId === slot.id && (
                      <DeleteConfirmation
                        onConfirm={() => handleDelete(slot.id ?? "")}
                        onCancel={handleCancel}
                        message={t("adminPrograms.counsellingForm.thisSlot", "this Slot")}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </>
        ))}
      </div>
      <button
        className=" mt-6 p-2 text-[#FFFFFF] bg-[#B4804A] rounded-lg border-2 border-[#B4804A]"
        onClick={() => openPopup()}
      >
        <span className="flex flex-row justify-center text-lg font-semibold text-center">
          <img src="./images/plus.png" alt="" />
          {t("adminPrograms.counsellingForm.addNewSlot", "Add New Counselling Slot")}
        </span>
      </button>
      {isPopupOpen && (
        <CounsellingSessionsAddPopup
          closePopup={closePopup}
          programId={programId}
        />
      )}
    </div>
  );
};

export default CounsellingSessions;
